export default __webpack_public_path__ + "static/Alex_Mobile-15c73c1da61427ad526f24db6a6b7180.jpg";